import workspaceQuery from '../../queries/salesLedger/SalesCreditWorkspaceQuery.graphql';
import instanceQuery from '../../queries/salesLedger/SalesCreditQuery.graphql';
import temporaryQuery from '../../queries/salesLedger/SalesCreditTempQuery.graphql';
import defaultQuery from '../../queries/salesLedger/SalesCreditDefault.graphql';
import mutationQuery from '../../mutations/salesLedger/SalesCreditMutation.graphql';
import temporaryMutationQuery from '../../mutations/salesLedger/SaveSalesCreditTempMutation.graphql';
import fragment from '../../fragments/salesLedger/SalesCreditFragment.graphql';
import aggregateQuery from '../../queries/salesLedger/SalesCreditAggregateQuery.graphql';

import { formActionsForPermissions } from '../../../actions/salesLedger/SalesCreditAction';

import { printFunctions } from '../../../actions/salesLedger/SalesCreditPrintFunctions';
import SalesCreditReportMutation from '../../mutations/salesLedger/SalesCreditReportMutation.graphql';
import SalesCreditsReportMutation from '../../mutations/salesLedger/SalesCreditsReportMutation.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';
import { workspaceActionsForPermissions } from '../../../actions/salesLedger/SalesCreditWorkspaceActions';

const SalesCredit: EntityType = {
  type: 'SalesCredit',
  title: 'Sales Credits',
  formTitle: 'Sales Credit',
  formUrl: '/Customers/Credit/Details/',
  workspaceUrl: '/Customers/Credit/Workspace/',
  instance: instanceQuery,
  temporaryDefaultQuery: temporaryQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_CREDITS',
  actions: [...workspaceActionsForPermissions, ...formActionsForPermissions],
  printFunctions: printFunctions,
  generate: SalesCreditReportMutation,
  generateRange: SalesCreditsReportMutation,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
  configuration: {
    title: 'Sales Credit',
    field: 'salesCreditDocumentDefault',
    reportType: ReportType.SalesCredit,
    customerField: 'customerCreditDocumentDefault',
    receiveFlag: 'receiveCreditDocuments',
  },
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'salesOrderNumbers',
      text: 'Sales Order Numbers',
    },
  ],
};

export default SalesCredit;
